module.exports = {
  license: "3f39d564-2c19-49e6-ac61-b014459d6cf2",
  config: {
    fields: [
      {
        label: "First Name",
        key: "first_name",
        isRequired: true,
      },
      {
        label: "Last Name",
        key: "last_name",
        isRequired: true,
      },
      {
      label: "Email Address",
      key: "email",
      description: "Our default method to send videos.",
      isRequired: true,
      validator: 'email'
    },
    {
      label: "Phone Number",
      key: "phone_number",
      description: "Optional. We use this to SMS your contacts."
    },
    {
      label: "Communication Channel",
      key: "communication_channel",
      description: "'sms' or 'email'"
    },
    {
      label: "Total Donated",
      key: "donations_collected",
      description: "A roll up of all donations to date."
    },
    {
      label: "Supporter Type",
      key: "type_of_supporter",
      description: "'lapsed', 'one-time', 'monthly'"
    },
    {
      label: "Created Date",
      key: "created_date",
      isRequired: true,
    },
    {
      label: "Link to CRM",
      key: "link_to_crm",
    },
    ],
    type: "Contacts",
    allowInvalidSubmit: false,
    managed: true,
    allowCustom: true,
    disableManualInput: false
  }
};
